/**
 * Route copy for `src/routes/grants` (keys: `routes.grants.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  grantRequestsPage: {
    tooManyRequestsLimitTemporarilyReached: 'Too many requests — limit temporarily reached. Wait a moment, then try again.',
    serviceTemporarilyUnavailableCheckYourCo: 'Service temporarily unavailable. Check your connection and try again.',
    couldNotLoadTheRightsRequests: 'Could not load the rights requests.',
    requestApprovedVV2GrantedTo: 'Request approved — {{v}} “{{v2}}” granted to {{v3}}.',
    requestRejectedVDoesNotGet: 'Request rejected — {{v}} does not get “{{v2}}”.',
    theActionOnTheRequestFailed: 'The action on the request failed.',
    lengthPending: '{{length}} pending',
    lengthTotalPendingcountPending: '{{length}} total · {{pendingCount}} pending',
    rightsRequests: 'Rights requests',
    agentsRequestingAccessToATool: 'Agents requesting access to a tool or skill — approve or reject each request, with a reason and, for a session, a duration.',
    refreshing: 'Refreshing…',
    refresh: 'Refresh',
    ownerOrAdministratorRoleRequiredTo: 'Owner or administrator role required to approve or reject a request. You can view the list read-only.',
    theAiRegistryCouldNotBe: 'The AI registry could not be read completely — some agents or capabilities are shown by their identifier.',
    status: 'Status',
    filterByStatus: 'Filter by status',
    loadingRightsRequests: 'Loading rights requests…',
    noRequest: 'No request',
    nothingToReviewForNowWhen: 'Nothing to review for now. When an agent needs a tool or skill it does not hold, its request appears here.',
    noRequestMatchesThisFilter: 'No request matches this filter.',
    reservedForTheOrganizationSOwner: 'Reserved for the organization\'s owner or an administrator.',
    grantScope: 'Grant scope',
    theGrantedDurationHasElapsed: 'The granted duration has elapsed',
    expired: 'Expired',
    requestedOnV: 'Requested on {{v}}',
    expiresOnV: ' · expires on {{v}}',
    agent: 'Agent:',
    requestedBy: 'Requested by:',
    session: 'Session:',
    decidedBy: 'Decided by:',
    decidedOn: 'Decided on:',
    binding: 'Binding:',
    requestReason: 'Request reason:',
    decisionReason: 'Decision reason:',
    approve: 'Approve…',
    reject: 'Reject…',
    sessionGrantYouCanSetA: 'Session grant: you can set a duration on approval.',
    approveTheRequest: 'Approve the request',
    rejectTheRequest: 'Reject the request',
    cancel: 'Cancel',
    approving: 'Approving…',
    rejecting: 'Rejecting…',
    confirmTheApproval: 'Confirm the approval',
    confirmRejection: 'Confirm rejection',
    grantV: 'Grant {{v}}',
    toTheAgent: 'to the agent',
    denyV: 'Deny {{v}}',
    approvalImmediatelyCreatesTheAgentCapabi: 'Approval immediately creates the agent ↔ capability binding on the server; the agent can use it from its next run.',
    grantDuration: 'Grant duration',
    beyondThisDurationTheCapabilityIs: 'Beyond this duration, the capability is removed automatically even if the session is still open.',
    reasonOptional: 'Reason (optional)',
    keptInTheRequestHistoryDecision: 'Kept in the request history (decision reason).',
    eGNeededForThisWeek: 'E.g. needed for this week\'s campaign, reviewed with the team.',
    eGToolOutsideThisAgent: 'E.g. tool outside this agent\'s scope.',
  },
};

export default en;
